import { render, staticRenderFns } from "./CategoryTiles.vue?vue&type=template&id=6098e076&scoped=true&"
import script from "./CategoryTiles.vue?vue&type=script&lang=js&"
export * from "./CategoryTiles.vue?vue&type=script&lang=js&"
import style0 from "./CategoryTiles.vue?vue&type=style&index=0&id=6098e076&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6098e076",
  null
  
)

export default component.exports